import { PickerPanel } from 'rc-picker';
import styled from 'styled-components';
import { pickerCommonStyles } from '../common.styled';

export const PickerPanelSC = styled(PickerPanel)`
  ${pickerCommonStyles}
`;

export const PanelWrapper = styled.div`
  z-index: 99999;
  transition: all 0.05s;
`;
